<template>
  <div>
    <Progress progress="82"></Progress>
    <div class="container">
      <div class="header-title">
        {{ severForm.name }}
      </div>
      <div class="hr"></div>
      <template v-for="item in severForm.children">
        <div
          v-if="(ans_11_6 != 1 || item.id == 6) && !(openStatus == 1 && item.id == 3)"
          :key="item.id"
          :class="{'isCheck': idList.includes(item.id)}"
          class="card"
          @click="handCheck(item.id)"
        >
          <img :src="item.id == 3 ? future : security" class="goods-img" />
          <div class="card-body">
            <div class="title">
              {{ item.name }}
            </div>
            <div class="content">
              {{ item.content }}
            </div>
            <div>
              <Icon v-if="idList.includes(item.id)" :name="bgColor == 'black-theme' ? darkIcon : selectIcon" class="check-mark" size="39" />
            </div>
          </div>
        </div>
      </template>
      <nav-buttons @on-next="handRecommend" :disabled="getNextDisabled || detailLoading"></nav-buttons>
    </div>
  </div>
</template>

<script>
import { Icon, Toast } from "vant";
import navButtons from "../components/navButtons.vue";
import Progress from "../components/Progress.vue";
import selectIcon from "@/assets/images/open-account/select.png";
import future from "@/assets/images/open-account/future.png";
import security from "@/assets/images/open-account/security.png";
import darkIcon from '@/assets/images/open-account/darkChoose.png'

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    Icon,
    Progress,
    navButtons
  },
  data() {
    return {
      selectIcon,
      future,
      security,
      darkIcon,
      severForm: {
        name: "",
        children: []
      },
      idList: [],
      process_id:'',
      openStatus:'',
      detailLoading:true,
      ans_11_6: '' , // 11步 第六题的答案
    };
  },
  computed: {
    bgColor() {
      return this.$store.getters["common/bgColor"];
    },
    getNextDisabled(){
      let btnDisabled = false
      if(this.idList.length == 0){
        btnDisabled = true
      }
      return btnDisabled
    }
  },
  created() {
    this.handList();
    this.handDetail();
  },
  methods: {
    handList() {
      this.$apis.accountServerNewLists().then(res => {
        if (res && res.disabled_list.length > 0) {
          const { disabled_list } = res
          this.severForm.name = disabled_list[0].name;
          this.severForm.children = disabled_list[0].children;
        }
      });
    },
    handDetail() {
      const params = {
        step_code:'1,7,11,12'
      }
      this.$apis.accountSituationV2(params).then(res => {
        const { config_data } = res?.process_info?.["12"] || {};
        const { process_id } = res?.process_info?.['1']
        this.process_id = process_id

        // 第7步适当性：衍生品选「否」(value=1) 时不展示期货
        try {
          const surveyForm = res?.process_info?.["7"]?.config_data;
          if (surveyForm) {
            const parsed = typeof surveyForm === "string" ? JSON.parse(surveyForm) : surveyForm;
            const value = parsed?.examine_list?.derivative?.t0?.value;
            if (value !== undefined && value !== null && value !== "") {
              this.openStatus = value;
            }
          }
        } catch (error) {
          console.log("[serverOpening] 解析适当性调查数据失败:", error);
        }

        if(res?.process_info?.["11"]?.config_data){
          try {
            const ans_11 = JSON.parse(res.process_info["11"].config_data);
            this.ans_11_6 = ans_11?.customer_state?.[5]?.value;
          } catch (error) {
            console.log("[serverOpening] 解析客户声明数据失败:", error);
          }
        }
        if (config_data) {
          try {
            const form = JSON.parse(config_data);
            if (this.severForm.children.length != 0 && form.server_id != null && form.server_id !== "") {
              if (String(form.server_id).indexOf(",") > -1) {
                const array = form.server_id.split(",") // 数组构成
                const numArray = array.map(Number) // 将数组里的值对应转换
                this.idList = numArray;
              } else {
                this.idList = [Number(form.server_id)];
              }
            }
          } catch (error) {
            console.log("[serverOpening] 解析开通服务数据失败:", error);
          }
        }
        this.removeFuturesIfNeeded();
        this.detailLoading = false
      });
    },
    // 衍生品选「否」时，清理已勾选的期货(id=3)
    removeFuturesIfNeeded() {
      if (this.openStatus == 1) {
        this.idList = this.idList.filter(item => item != 3);
      }
    },
    handCheck(id) {
      if(this.openStatus == 1 && id == 3){
        this.removeFuturesIfNeeded();
        return;
      }
      if (this.idList.includes(id)) {
        this.idList = this.idList.filter(item => item != id);
      } else {
        this.idList.push(id);
      }
    },
    handRecommend() {
     if(this.getNextDisabled || this.detailLoading){
       return
     }
      this.removeFuturesIfNeeded();
      if (this.severForm.children.length != 0) {
        const server_id = this.idList.join(",");
        const params = {
          process_id:this.process_id,
          step_code: 12,
          step_order: 12,
          config_data: {
            server_id
          }
        };
        const toastLoading = Toast.loading({
          duration: 0,
          forbidClick: true,
          loadingType: "spinner",
          message: this.$t("common.loading_text")
        });
        this.$apis.supplementSaveApi(params).then(res => {
          if (res) {
            this.$router.push({
              path: "/open-account/riskDisclosure"
            }).finally(() => {
              toastLoading.clear();
            });
          }
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  padding: 40px;
  margin-top: 62px;

  .header-title {
    font-size: 36px;
    font-weight: 500;
    color: #17161C;
  }
  .hr{
    border-bottom: 1px solid #F3F3F3;
    width: 130%;
    margin-left: -40px;
    margin-top: 26px;
  }

  .card {
    border-radius: 24px;
    margin-top: 22px;
    background: #F6F7FA;
    display: flex;
    padding: 45px;
    position: relative;
    border: 1px solid transparent;

    .goods-img {
      width: 80px;
      height: 80px;
      object-fit: contain;
    }

    .card-body {
      margin-left: 15px;
      margin-top: -5px;

      .title {
        font-size: 32px;
        font-weight: 500;
        color: #17161C;
      }

      .content {
        font-size: 28px;
        color: #747377;
        margin-top: 10px;
      }

      .check-mark {
        position: absolute;
        bottom: -2px;
        right: -2px;
      }
    }

  }

  .isCheck {
    border: 1px solid #777777;
  }
  .isdisable{
    display: none;
    opacity: .4;
  }
}
.black-theme{
  .container{
    .header-title{
      color: #FFFFFF;
    }
    .hr{
      border-bottom: 1px solid #2D2F3B;
    }
    .card{
      background: #0A0B0F;
      .card-body{
        .title{
          color: #FFFFFF;
        }
        .content{
          color: #9D9D9F;
        }
      }
    }
    .isCheck{
      border: 1px solid #377cfb;
    }
  }
}
</style>
